import angular from 'angular';
import Logger from '../../../shared/logger';

export const CandidatesExportService = (Restangular) => {
    const getCandidatesDataByTalentIds = function ({
        positionId,
        talentIds,
        maxItems,
        filters,
    }) {
        return Restangular
            .all('export')
            .all('searchCandidates')
            .post({
                positionId,
                talentIds,
                maxItems,
                filters,
            })
            .catch(error => Logger.error(error));
    };

    return {
        getCandidatesDataByTalentIds,
    };
};

angular
    .module('TALENYA-FE')
    .factory('CandidatesExportService', CandidatesExportService);
